import AbstractService from 'core/abstracts/AbstractService';
import Facade from 'core/Facade';

class HighlightedItemsService extends AbstractService {
    gethighlightedItems(status, date) {
        const query = `?date=${date}&status=${status}`;
        const finalUrl = Facade.getApiRoot() + `bo/spe-highlighted-items${query}`;
        return this.request({
            method: 'GET',
            url:  finalUrl,
        }).then(async (responseData) => {
            if (responseData.ok) {
                return await responseData.json();
            }
            throw await responseData.json();
        });
    }
}

export default new HighlightedItemsService();
